import { cn } from '@heidi/utils';
import { AlertCircle } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

import { projectRunFailureMessages } from '../../../data/projects/components/projectRunFailure.messages';

/**
 * Surfaces a failed Work turn so the user has a clear, actionable
 * terminal state instead of an infinite spinner. The upstream failure
 * reason is intentionally not shown — it's a raw SDK/technical string
 * (e.g. `BadRequestError: 400 …`) that's meaningless to users; the
 * detail stays in the backend logs.
 *
 * Note: the in-flight "desktop tool running" indicator that used to
 * live here has been folded into the `ComputerUseTaskBlock` itself —
 * the block now owns its own loader (canonical Evidence
 * `ChatLoadingIndicator` + a real step ladder driven by the delegate
 * trace), so the chat surface no longer needs a separate sibling
 * indicator.
 */
export const RunFailedBanner = () => (
  <div
    className={cn(
      'flex items-start gap-3 rounded-lg border border-validation-destructive-muted bg-validation-destructive-muted/40 p-3',
      'duration-300 animate-in fade-in'
    )}
    role="alert"
  >
    <AlertCircle className="mt-0.5 size-4 shrink-0 text-validation-destructive" />
    <div className="flex flex-col gap-1">
      <span className="text-sm font-medium text-text-primary">
        <FormattedMessage {...projectRunFailureMessages.bannerTitle} />
      </span>
      <span className="text-xs text-text-tertiary">
        <FormattedMessage {...projectRunFailureMessages.bannerDescription} />
      </span>
    </div>
  </div>
);
